

import SelectAll from './components/SelectAll';

export default SelectAll;



// WEBPACK FOOTER //
// ./src/lib/index.js